import React from 'react';
import GlassPanel from '@/components/ui/GlassPanel';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiUser, FiBell, FiShield, FiCpu } = FiIcons;

export default function Settings() {
  return (
    <div className="space-y-6 pb-24 md:pb-8 animate-in fade-in duration-500">
      
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
         <div>
           <h1 className="text-3xl font-bold text-white tracking-tight">System Configuration</h1>
           <p className="text-gray-400 text-sm mt-1">Adjust preferences and neural interface settings.</p>
         </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        
        {/* Sidebar Nav for Settings */}
        <div className="md:col-span-3 space-y-2">
          {['Profile Identity', 'Alerts & Telemetry', 'Security Protocols', 'API Integrations'].map((item, i) => (
            <button key={item} className={`w-full text-left px-4 py-3 rounded-lg text-sm font-mono flex items-center gap-3 transition-colors ${i === 0 ? 'bg-bb-gold/10 text-bb-gold border border-bb-gold/20' : 'text-gray-400 hover:bg-bb-glass hover:text-white'}`}>
              <SafeIcon icon={[FiUser, FiBell, FiShield, FiCpu][i]} />
              <span className="truncate">{item}</span>
            </button>
          ))}
        </div>

        {/* Settings Content */}
        <div className="md:col-span-9 space-y-6">
          <GlassPanel className="p-6">
            <h3 className="text-xs text-bb-accent font-mono uppercase tracking-[0.2em] mb-6 border-b border-bb-glassBorder pb-3">Identity Parameters</h3>
            
            <div className="flex items-center gap-6 mb-8 group cursor-pointer">
              <div className="w-20 h-20 rounded-full bg-bb-dark border-2 border-bb-glassBorder group-hover:border-bb-gold transition-colors flex items-center justify-center relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-bb-gold/20 to-transparent opacity-50"></div>
                <span className="font-mono text-2xl text-white relative z-10">CX</span>
              </div>
              <div>
                <button className="bg-white/5 hover:bg-white/10 border border-white/10 text-white px-4 py-2 rounded-lg text-xs font-mono uppercase tracking-wider transition-colors mb-2">Update Hologram</button>
                <p className="text-xs text-gray-500">JPG, PNG or GIF. Max 5MB.</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-[10px] text-gray-400 font-mono uppercase mb-2">Designation (Name)</label>
                <input type="text" defaultValue="Commander X" className="w-full bg-bb-dark border border-bb-glassBorder rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-bb-gold transition-colors" />
              </div>
              <div>
                <label className="block text-[10px] text-gray-400 font-mono uppercase mb-2">Comms Link (Email)</label>
                <input type="email" defaultValue="cx@sector7.gal" className="w-full bg-bb-dark border border-bb-glassBorder rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-bb-gold transition-colors" />
              </div>
            </div>
            
            <div className="mt-8 flex justify-end">
              <button className="bg-bb-gold text-bb-dark px-6 py-2.5 rounded-lg text-xs font-bold font-mono uppercase tracking-wider hover:bg-yellow-400 transition-colors">Save Parameters</button>
            </div>
          </GlassPanel>

          <GlassPanel className="p-6">
            <h3 className="text-xs text-bb-accent font-mono uppercase tracking-[0.2em] mb-6 border-b border-bb-glassBorder pb-3">System Information</h3>
            <div className="space-y-4 text-sm font-mono">
              <div className="flex justify-between border-b border-white/5 pb-2">
                <span className="text-gray-500">Build Version</span>
                <span className="text-white">v2.1.0-omega</span>
              </div>
              <div className="flex justify-between border-b border-white/5 pb-2">
                <span className="text-gray-500">Core Engine</span>
                <span className="text-white">React / Vite</span>
              </div>
              <div className="flex justify-between pb-2">
                <span className="text-gray-500">Credits</span>
                <span className="text-bb-gold font-bold">Made by LingLink AI and DigLab AI</span>
              </div>
            </div>
          </GlassPanel>
        </div>
      </div>
    </div>
  );
}